import React, { useState, useEffect, useContext } from "react";
import './rightDetails.scss';
import { TiStarFullOutline, TiStarHalfOutline, TiStarOutline } from "react-icons/ti";
import { useParams } from 'react-router-dom';
import candidateApi from "../../services/candidateApi";
import { AuthContext } from "../../context/AuthContext";
import { toast } from "react-toastify";

export const RatingDetails = (loadDetail) => {
  let { id } = useParams();
  const { candidateIdValue, setCandidateIdValue } = useContext(AuthContext);
  const [assessmentDetails, setAssessmentDetails] = useState([]);  
  const [candidateDetails, setCandidateDetails] = useState([]);     
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [averageRatings, setAverageRatings] = useState([]);

  const { setReloadDataFunc } = useContext(AuthContext);
  
  const fetchDetails = async () => {
    try {
      if (!id){
        id=candidateIdValue;
      }
      const response = await candidateApi.getJobsByCandidate(id);
      console.log("API Response:", response?.data); 
      if (response?.data?.length > 0) {
        setCandidateDetails(response.data);
        // setSelectedJobId(response.data[0].jobId);  
        const maxJob = response.data.reduce((max, job) =>
          job.jobId > max.jobId ? job : max
        );
        setSelectedJobId(maxJob.jobId);
      } 
    } catch (error) {
      console.error("Error fetching candidate details:", error);
    }
  };
  useEffect(() => {
  fetchDetails();
  }, [id]);
  const loadDetails = async () => {
    try {
      if (!id){
        id=candidateIdValue;
      }
      const jobId=selectedJobId; 
      const response = await candidateApi.fetchAssessmentWithRatings(id,jobId);
      const avgRatings = response?.data?.averageRatings ? Object.values(response.data.averageRatings) : [];
      setAverageRatings(avgRatings);
    } catch (error) {
      toast.error("Error fetching average ratings data", {
                position: "top-right", 
                autoClose: 2000,
              });
      console.error("Error fetching averageRatings details:", error);
    }
  }; 
  useEffect(() => {
    setReloadDataFunc(() => loadDetails);
  loadDetails();
  }, [id,selectedJobId]);
  useEffect(() => {
    if (loadDetail) { 
      loadDetails();
    }
  }, [loadDetail]);

    // Calculate overall rating
    
    const calculateOverallRating = () => {
      if (averageRatings.length === 0) return 0;
      const totalRating = averageRatings.reduce((acc, rating) => acc + parseFloat(rating.averageRating), 0);
      return (totalRating / averageRatings.length).toFixed(2);  // Ensures consistency
    };
    
    const renderStars = (rating) => {
      const numericRating = parseFloat(rating);
      const fullStars = Math.floor(numericRating);
      const decimalPart = numericRating - fullStars;
      const halfStars = decimalPart >= 0.5 ? 1 : 0;
      const emptyStars = 5 - fullStars - halfStars;
    
      return (
        <>
          {[...Array(fullStars)].map((_, idx) => (
            <TiStarFullOutline key={`full-${idx}`} className="starfull" />
          ))}
          {halfStars === 1 && <TiStarHalfOutline className="starhalf" />}
          {[...Array(emptyStars)].map((_, idx) => (
            <TiStarOutline key={`empty-${idx}`} className="starempty" />
          ))}
        </>
      );
    };
  const overallRating = calculateOverallRating();
 
  return (
    <section className="card ">
      <div className="d-flex p-3 gap-3 align-items-center">
      <div className="overall-info position-relative">
        <h6>{parseFloat(overallRating).toFixed(1)}<em>/</em><span>5</span></h6>

        <div className="rating-info ">
          <div className="stars d-flex gap-2 align-items-center">
          {renderStars(overallRating)}
          </div>
          <label className="form-label mb-0" >
            Overall Rating
          </label>

        </div>
      </div>

      <div className="rate-details">
      {averageRatings.map((rating, idx) => (

        <div className="d-flex gap-3 align-items-center mb-2">
          <div className="label">{rating.criteriaValue}</div>
          <div className="bar-container d-flex gap-2 align-items-center">
            <div className="bar-holder position-relative">
              <div className="bar">
              <div className="bar-progress" style={{ width: `${(rating.averageRating / 5) * 100}%` }}></div>
              </div>
            </div>
            <div className="ms-auto">
            <span className="star selected">
              <TiStarFullOutline />
            </span>
            <span className="count">
            {rating.averageRating % 1 === 0 ? parseInt(rating.averageRating) : parseFloat(rating.averageRating).toFixed(1)}
          </span>
            </div>           
          </div>
        </div>
        ))}


        {/*  <div className="d-flex gap-3 align-items-center mb-2">
           <div className="label">Technical Knowledge</div>
           <div className="bar-container d-flex gap-2 align-items-center">
             <div className="bar-holder position-relative">
               <div className="bar">
               <div className="bar-progress" style={{ width: "75%" }}></div>

               </div>
             </div>
             <div className="ms-auto">
             <span className="star selected">
               <TiStarFullOutline />
             </span>
             <span className="count">
               3
             </span>
             </div>
           </div>
         </div>
         <div className="d-flex gap-3 align-items-center mb-2">
           <div className="label">Experience</div>
           <div className="bar-container d-flex gap-2 align-items-center">
             <div className="bar-holder position-relative">
               <div className="bar">
               <div className="bar-progress" style={{ width: "75%" }}></div>

               </div>
             </div>
             <div className="ms-auto">
             <span className="star selected">
               <TiStarFullOutline />
             </span>
             <span className="count">
               3
             </span>
             </div>
           </div>
         </div>
         <div className="d-flex gap-3 align-items-center mb-2">
           <div className="label">Package</div>
           <div className="bar-container d-flex gap-2 align-items-center">
             <div className="bar-holder position-relative">
               <div className="bar">
               <div className="bar-progress" style={{ width: "0" }}></div>

               </div>
             </div>
             <div className="ms-auto">
             <span className="star">
               <TiStarFullOutline />
             </span>
             <span className="count">
               0
             </span>
             </div>
           </div>
         </div> */}
      </div>
      </div>
    </section>
  );
}

